var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
/** 出租率进度条参考宽度（px）：全店 quantity 占满此宽度，其余按比例换算 */
var BAR_REFERENCE_WIDTH = 100;
/**
 * 进度条单元格
 * - 灰色条宽度 = (quantity / maxQuantity) * BAR_REFERENCE_WIDTH
 *   全店 = 所有房型 quantity 之和，占满 100；其余行为该房型自己的 quantity
 * - 蓝色条暂不处理（先保证灰色宽度正确）
 */
export var ProgressCell = function (_a) {
    var progress = _a.progress, quantity = _a.quantity, quantityOpen = _a.quantityOpen, maxQuantity = _a.maxQuantity, _b = _a.strokeColor, strokeColor = _b === void 0 ? "#1890ff" : _b;
    var soldQuantity = Math.max(0, quantity - (quantityOpen !== null && quantityOpen !== void 0 ? quantityOpen : 0));
    // 灰色条：quantity 换算后的长度，100 代表 maxQuantity
    // 全店（quantity = maxQuantity）占满 100px，其余行按 quantity 比例换算
    var greyPx = maxQuantity > 0 && quantity > 0
        ? (quantity / maxQuantity) * BAR_REFERENCE_WIDTH
        : 0;
    // 蓝色条：(quantity - quantityOpen) 换算后的长度，占灰色条的比例 = 出租率
    var bluePx = maxQuantity > 0 && soldQuantity > 0
        ? (soldQuantity / maxQuantity) * BAR_REFERENCE_WIDTH
        : 0;
    return (_jsxs("div", __assign({ style: {
            display: "flex",
            alignItems: "center",
            gap: 8,
            width: "100%",
            minWidth: 0,
        } }, { children: [_jsx("div", __assign({ style: {
                    width: "".concat(greyPx, "px"),
                    flexShrink: 0,
                    position: "relative",
                    height: 8,
                    backgroundColor: "#e8e8e8",
                    borderRadius: 4,
                    overflow: "hidden",
                    minWidth: greyPx > 0 ? '1px' : '0px',
                } }, { children: _jsx("div", { style: {
                        position: "absolute",
                        left: 0,
                        top: 0,
                        width: "".concat(bluePx, "px"),
                        height: "100%",
                        backgroundColor: strokeColor,
                        borderRadius: 4,
                        transition: "width 0.2s ease",
                    } }) })), _jsxs("span", __assign({ style: {
                    fontSize: 12,
                    color: "#666",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                } }, { children: [Math.max(0, Math.min(100, progress)).toFixed(1), "%"] }))] })));
};
